
import { defineComponent } from "vue";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";
import { Button, Icon, IconButton, ModalWindow } from "@/shared/ui";

export default defineComponent({
	name: "ManageMentalState",
	components: {
		IconButton,
		Button,
		Icon,
		ModalWindow,
	},
	setup() {
		const store = useCharactersStore();

		const { characters, current, maxMental } = storeToRefs(store);
		const { updateName, updateRace, updateLuck } = store;

		return {
			characters,
			current,
			maxMental,
			updateName,
			updateRace,
			updateLuck,
		};
	},
	data() {
		return {
			modal: false,
			value: 0,
			modifier: 0,
		};
	},
	watch: {
		modal() {
			this.value = 0;
			this.modifier = this.characters[this.current].mental.modifier;
		},
	},
	mounted() {
		this.modifier = this.characters[this.current].mental.modifier;
	},
	methods: {
		heal() {
			this.characters[this.current].mental.current = Math.min(
				this.characters[this.current].mental.current + this.value,
				this.maxMental
			);
			this.close();
		},
		damage() {
			this.characters[this.current].mental.current = Math.max(
				this.characters[this.current].mental.current - this.value,
				0
			);
			this.close();
		},
		changeModifier() {
			this.characters[this.current].mental.modifier = this.modifier;
			this.close();
		},
		close() {
			this.value = 0;
			this.modal = false;
		},
	},
});
